import React from 'react';
import { Link } from 'react-router-dom';

const Services = () => {
  return (
    <div>
      {/* Hero Section */}
      <section className="section-light py-16">
        <div className="container mx-auto px-4 text-center">
          <h1 className="page-title">Comprehensive coverage made simple.</h1>
          <p className="text-lg text-gray-700 max-w-3xl mx-auto">
            From protecting your home to securing your family's future, we offer complete 
            insurance solutions tailored to your unique needs.
          </p>
        </div>
      </section>

      {/* Services Grid */}
      <section className="py-16">
        <div className="container mx-auto px-4">
          <div className="space-y-16">
            
            {/* Home Insurance */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="flex items-center mb-4">
                  <div className="text-5xl text-accent-orange mr-4">🏠</div>
                  <h2 className="text-3xl font-bold text-primary-blue">Home Insurance</h2>
                </div>
                <p className="text-lg text-gray-600 mb-6">
                  Safeguard your home, belongings, and peace of mind with comprehensive coverage 
                  that protects against fire, theft, storms, and liability.
                </p>
                <ul className="space-y-2 text-gray-600 mb-6">
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Dwelling coverage</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Personal property protection</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Liability coverage</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Additional living expenses</li>
                </ul>
                <Link to="/quote" className="btn-primary">Get Home Quote</Link>
              </div>
              <div className="bg-gradient-to-br from-primary-blue to-deep-navy p-8 rounded-lg info-box-text">
                <h3 className="text-xl font-bold mb-4">Popular Coverage Options</h3>
                <div className="space-y-3">
                  <div>Replacement Cost Coverage</div>
                  <div>Personal Umbrella Policy</div>
                  <div>Flood Insurance</div>
                  <div>Home Business Coverage</div>
                </div>
              </div>
            </div>

            {/* Auto Insurance */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1 bg-gradient-to-br from-accent-orange to-rust-amber p-8 rounded-lg info-box-text">
                <h3 className="text-xl font-bold mb-4">Coverage Types</h3>
                <div className="space-y-3">
                  <div>Liability Coverage (Required)</div>
                  <div>Collision & Comprehensive</div>
                  <div>Uninsured Motorist</div>
                  <div>Medical Payments</div>
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <div className="flex items-center mb-4">
                  <div className="text-5xl text-accent-orange mr-4">🚗</div>
                  <h2 className="text-3xl font-bold text-primary-blue">Auto Insurance</h2>
                </div>
                <p className="text-lg text-gray-600 mb-6">
                  Drive with confidence knowing you're covered. From liability to full coverage, 
                  we help you find the right protection at the right price.
                </p>
                <ul className="space-y-2 text-gray-600 mb-6">
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Multi-car discounts</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Safe driver rewards</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Roadside assistance</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Rental car coverage</li>
                </ul>
                <Link to="/quote" className="btn-primary">Get Auto Quote</Link>
              </div>
            </div>

            {/* Renters Insurance */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="flex items-center mb-4">
                  <div className="text-5xl text-accent-orange mr-4">🔑</div>
                  <h2 className="text-3xl font-bold text-primary-blue">Renters Insurance</h2>
                </div>
                <p className="text-lg text-gray-600 mb-6">
                  Protect your valuables and liability, even without owning. Affordable coverage 
                  for your belongings and peace of mind.
                </p>
                <ul className="space-y-2 text-gray-600 mb-6">
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Personal property coverage</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Liability protection</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Additional living expenses</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Identity theft protection</li>
                </ul>
                <Link to="/quote" className="btn-primary">Get Renters Quote</Link>
              </div>
              <div className="bg-gradient-to-br from-maroon to-deep-navy p-8 rounded-lg info-box-text">
                <h3 className="text-xl font-bold mb-4">Why Renters Need Insurance</h3>
                <div className="space-y-3 text-sm">
                  <div>• Landlord's insurance doesn't cover your belongings</div>
                  <div>• Protects against theft and damage</div>
                  <div>• Covers temporary housing costs</div>
                  <div>• Often required by lease agreements</div>
                </div>
              </div>
            </div>

            {/* Liability/Umbrella */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div className="order-2 lg:order-1 bg-gradient-to-br from-primary-blue to-maroon p-8 rounded-lg info-box-text">
                <h3 className="text-xl font-bold mb-4">When You Need Umbrella</h3>
                <div className="space-y-3 text-sm">
                  <div>• High net worth or assets</div>
                  <div>• Public-facing profession</div>
                  <div>• Frequent entertaining</div>
                  <div>• Teen drivers in household</div>
                </div>
              </div>
              <div className="order-1 lg:order-2">
                <div className="flex items-center mb-4">
                  <div className="text-5xl text-accent-orange mr-4">🛡️</div>
                  <h2 className="text-3xl font-bold text-primary-blue">Liability/Umbrella</h2>
                </div>
                <p className="text-lg text-gray-600 mb-6">
                  Extra coverage when life throws the unexpected. Umbrella insurance provides 
                  additional liability protection beyond your standard policies.
                </p>
                <ul className="space-y-2 text-gray-600 mb-6">
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Excess liability coverage</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Worldwide protection</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Legal defense costs</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Affordable peace of mind</li>
                </ul>
                <Link to="/quote" className="btn-primary">Get Umbrella Quote</Link>
              </div>
            </div>

            {/* Life Insurance */}
            <div className="grid lg:grid-cols-2 gap-12 items-center">
              <div>
                <div className="flex items-center mb-4">
                  <div className="text-5xl text-accent-orange mr-4">❤️</div>
                  <h2 className="text-3xl font-bold text-primary-blue">Life Insurance</h2>
                </div>
                <p className="text-lg text-gray-600 mb-6">
                  Provide financial security for your loved ones' future. From term life to 
                  permanent coverage, we help you choose the right protection.
                </p>
                <ul className="space-y-2 text-gray-600 mb-6">
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Term life insurance</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Whole life insurance</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Universal life options</li>
                  <li className="flex items-center"><span className="text-accent-orange mr-2">•</span> Business life insurance</li>
                </ul>
                <Link to="/quote" className="btn-primary">Get Life Quote</Link>
              </div>
              <div className="bg-gradient-to-br from-accent-orange to-maroon p-8 rounded-lg info-box-text">
                <h3 className="text-xl font-bold mb-4">Life Insurance Benefits</h3>
                <div className="space-y-3">
                  <div>Income replacement for family</div>
                  <div>Mortgage and debt payoff</div>
                  <div>Children's education funding</div>
                  <div>Final expense coverage</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Bundle CTA */}
      <section className="section-dark py-16">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl font-bold text-white mb-4">Bundle & Save</h2>
          <p className="text-xl text-gray-300 mb-8">
            Combine multiple policies for maximum savings and convenience
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/quote" className="btn-primary text-lg px-8 py-4">
              Get Bundle Quote
            </Link>
            <a 
              href="https://calendly.com/g-garza-insure/herecomeprotection" 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-secondary text-lg px-8 py-4 text-white border-white hover:bg-white hover:text-deep-navy"
            >
              Discuss Options
            </a>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Services;